<template>


  <div v-if="planId" class="col-8 mx-auto py-5 mt-5 bg-light shadow">
    <div class="text-center">
      <h4 class="d-flex justify-content-between align-items-center mb-3">
        <span class="text-muted">Enter your card information to begin your subscription services</span><br>
      </h4>

      <h4 class="d-flex justify-content-between align-items-center mb-3">
        <span class="text-muted">Payment information is stored securely using Stripe payment processors</span><br>
      </h4>

      <h4 class="d-flex justify-content-between align-items-center mb-3">
        <span class="text-muted">Your account will be charged monthly for services provided</span>
      </h4>
    </div>
    <ul class="list-group mb-3">
      <li class="list-group-item d-flex justify-content-between lh-condensed">
        <div>
          <h6 class="my-0">Product name: {{ pl.metadata.product_name }}</h6>
          <br />
          <h6>Description:</h6>
          <small class="text-muted">{{ pl.metadata.description }} </small>
          <h6 class="mt-4">Interval:</h6>
            <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800">
              {{ pl.interval }}
            </span>
        </div>
        <span class="text-muted"></span>
      </li>


      <li class="list-group-item d-flex justify-content-between">
        <span>Total (USD)</span>
        <strong>{{ dollar(pl.amount) }}.00</strong>
      </li>
    </ul>

    <form id="payment-form">
      <input :value="planId" id="planId" type="hidden" />

      <input
        placeholder="Card Holder Name"
        class="form-control mb-2"
        id="card-holder-name"
        type="text"
      />
      <div id="card-element">
        <!-- Elements will create input elements here -->
      </div>

      <!-- We'll put the error messages in this element -->
      <div id="card-errors" role="alert"></div>
      <!-- <button id="submit">Pay</button> -->
      <button class="mt-2 btn btn-dark btn-lg btn-block" id="submit">
        Subscribe
      </button>
    </form>
  </div>


</template>

<script src="https://js.stripe.com/v3/"></script>
<script>
export default {

  data() {
    return {
      pl: {},
      clientSecret: "",
      planName: "",

      planId: ""
    };
  },


  mounted() {

      setTimeout(()=>{ this.getPlan() },1000);
      setTimeout(()=>{ this.gettingSub() },2000);
  },


  methods: {


    gettingSub() {

           // Create a Stripe client.
    var stripe = Stripe(process.env.VUE_APP_STRIPE);

    // Create an instance of Elements.
    var elements = stripe.elements();

    // Custom styling can be passed to options when creating an Element.
    // (Note that this demo uses a wider set of styles than the guide below.)
    var style = {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4"
        }
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    };

    // Create an instance of the card Element.
    var card = elements.create("card", { style: style });

    // Add an instance of the card Element into the `card-element` <div>.
    card.mount("#card-element");
    const cardHolderName = document.getElementById("card-holder-name");
    const plan = document.getElementById("planId").value;
    // Handle real-time validation errors from the card Element.
    card.on("change", function(event) {
      var displayError = document.getElementById("card-errors");
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = "";
      }
    });

    var client = window.axios
      .get("/api/getSub")
      .then(function(res) {

        var clientSecret = res.data.intent.client_secret;

        var form = document.getElementById("payment-form");

        form.addEventListener("submit", async e => {
          e.preventDefault();

          const { setupIntent, error } = await stripe.handleCardSetup(
            clientSecret,
            card,
            {
              payment_method_data: {
                billing_details: { name: cardHolderName.value }
              }
            }
          );

          if (error) {
            console.log(error.message);
          } else {
            // The card has been verified successfully...
            console.log("handling success", setupIntent.payment_method);
            axios
              .post("/api/subscription", {
                payment_method: setupIntent.payment_method,
                idPlan: res.data.plan.id,
                namePlan: res.data.plan.interval
              })
              .then(data => {
                console.log(data);
                // this.$emit("event")
                alert('Plan purchased successfully!');
                location.reload();
                // window.location.href = '/';
              });
          }
        });
      });

    },

    getPlan(){
        window.axios.get("/api/getPlan").then((res) => {
            this.pl = res.data.plan;
            this.subscription = res.data
            this.planId = res.data.plan.id
        });
      },

    dollar(value) {
      return value / 100;
    }
  }
};
</script>
